export default "__VITE_ASSET__Bl$NFIVK__"